import { AppState } from '@/types';
import { AppAction } from '../types';
import { initialState, getWeekStart } from '../initialState';

export function handleLogin(state: AppState, action: Extract<AppAction, { type: 'LOGIN' }>): AppState {
  return {
    ...state,
    user: action.payload.user,
    isAuthenticated: true,
    weeklyGoal: action.payload.user.weeklyGoal || state.weeklyGoal || 300
  };
}

export function handleLogout(): AppState {
  return {
    ...initialState,
    weeklyStartDate: getWeekStart()
  };
}